class LanguageRedirect {
  LS_KEY = "ele-user-language";

  constructor() {
    this.redirect();
    this.addLanguageLinksEventListener();
  }

  redirect() {
    if (document.documentElement.classList.contains('editmode')) {
      console.log("Detected editmode, not redirecting.");
      return;
    }

    if (window.location.href.includes('/account/')) {
      console.log("Detected account page, not redirecting.");
      return;
    }

    if (this.isCrawler()) {
      console.log("Detected crawler, not redirecting.");
      return;
    }

    const userLanguage = this.getUserLanguage();
    if (!userLanguage) {
      console.log("Unable to get user language");
      return;
    }

    const documentLanguage = document.documentElement.getAttribute("lang");

    // No redirect necessary
    if (userLanguage === documentLanguage) {
      console.log(`Current document matches user language: ${userLanguage}`);
      return;
    }

    const targetLink = document
      .querySelector(`link[rel="alternate"][hreflang="${userLanguage}"]`)
      ?.getAttribute("href");
    if (!targetLink) {
      console.log(`Missing translation in user language: ${userLanguage}`);
      return;
    }

    window.location.href = targetLink;
  }

  isCrawler() {
    // https://stackoverflow.com/a/33941034
    const botPattern =
      "(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    const re = new RegExp(botPattern, "i");
    return re.test(navigator.userAgent);
  }

  getUserLanguage() {
    // Get from local storage
    const savedLanguage = localStorage.getItem(this.LS_KEY);
    if (savedLanguage) {
      return savedLanguage;
    }

    // Get browser language
    const browserLanguage = navigator.language || navigator.userLanguage;
    if (browserLanguage) {
      return browserLanguage.substring(0, 2);
    }

    return null;
  }

  addLanguageLinksEventListener() {
    // Update local storage language on manual language switch
    document.querySelectorAll("a[data-language]").forEach((el) => {
      el.addEventListener("click", (e) => {
        localStorage.setItem(this.LS_KEY, el.getAttribute("data-language"));
      });
    });
  }
}

new LanguageRedirect();
